'use client';
import { createStorage } from '../createStorage/createStorage.js';

function useSessionStorage(props) {
    return createStorage('sessionStorage', 'useSessionStorage')(props);
}

export { useSessionStorage };
//# sourceMappingURL=useSessionStorage.js.map
